<template>
  <div
    class="schedule-item"
    :class="type"
    :style="itemBorderColor"
    @click.stop="handleClickScheduleItem"
  >
    <div class="title">
      {{ lesson.parent_course.name }}
    </div>

    <div
      v-show="type === 'daily'"
      class="description"
    >
      {{ lessonTime }}&nbsp;&nbsp;|&nbsp;&nbsp;{{ instructorNames }}&nbsp;<span v-show="isBookingSystem">&nbsp;|&nbsp; 예약&nbsp;{{ lesson.booked }}명</span>&nbsp;
    </div>
    <div
      v-show="type === 'weekly'"
      class="description"
    >
      {{ lessonTime }}&nbsp;<span v-show="isBookingSystem">&nbsp;|&nbsp; 예약&nbsp;{{ lesson.booked }}명</span>&nbsp;
    </div>
    <div
      v-show="type === 'monthly'"
      class="description"
    >
      {{ lessonTime }}
    </div>
  </div>
</template>

<script>
import dateFns from "date-fns";
import { mapGetters } from "vuex";

export default {
	name: "DailyScheduleItem",
	props: ["lesson", "type", "color"],
	computed: {
		...mapGetters(["getInstructorByIds"]),
		lessonTime() {
			let startStr = dateFns.format(this.lesson.start, "HH:mm");
			let endTime = dateFns.addMinutes(this.lesson.start, this.lesson.duration);
			let endStr = dateFns.format(endTime, "HH:mm");

			return `${startStr}-${endStr}`;
		},
		itemBorderColor() {
			if (!this.lesson.parent_course.color) {
				return {};
			}

			return {
				borderLeft: `3px solid ${this.lesson.parent_course.color}`,
			};
		},
		instructorNames() {
			return this.getInstructorByIds(this.lesson.instructors)
				.map(instructor => {
					return instructor ? instructor.name : null;
				})
				.filter(item => item)
				.join(", ");
		},
		isBookingSystem() {
			return this.$store.getters.getIsBookingSystem;
		},
	},
	methods: {
		handleClickScheduleItem() {
			this.$emit("click", this.lesson);
		},
	},
};
</script>

<style lang="scss">
.schedule-item {
	background-color: #f2f2f2;
	border-radius: 3px;
	border-left: 3px solid #224ba2;
	padding: 8px 6px 6px;
	box-sizing: border-box;

	.title {
		font-size: 16px;
		line-height: 16px;
		color: #4a4a4a;
		letter-spacing: -0.91px;
		font-weight: 300;
		display: block;
		margin-bottom: 8px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.description {
		line-height: 11px;
		font-weight: 300;
		font-size: 11px;
		color: #b9b9b9;
		letter-spacing: -0.8px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	@media screen and (max-width: 768px) {
		padding: 7px 6px;

		.title {
			font-size: 13px;
			line-height: 13px;
			margin-bottom: 4px;
		}

		.description {
			font-weight: 300;
			font-size: 11px;
			color: #b9b9b9;
			letter-spacing: -0.8px;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}

	&.daily {
	}

	&.weekly {
		.description {
			font-size: 11px;
		}
	}

	&.monthly {
		position: relative;
		height: 20px;
		padding: 0 4px;
		box-sizing: border-box;
		margin-bottom: 2px;
		display: flex;

		.title {
			font-size: 12px;
			line-height: 20px;
			height: 20px;
			letter-spacing: -0.69px;
			margin: 0;
			flex: auto;
		}

		.description {
			font-size: 10px;
			line-height: 20px;
			letter-spacing: -0.6px;
			width: 50px;
			flex: 0 0 auto;
		}
	}

	&:hover {
		background-color: #eeeeee;
		cursor: pointer;
		box-shadow: 0px 2px 8px rgba(195, 195, 195, 1);
		z-index: 1000;

		.description {
			background-color: #eeeeee;
		}
	}
}
</style>
